import { createCall, spellbook } from "@sdk/spellbook";

import { getAccountOrNetworkId, withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/organisations/{organisationId}/documents/unsigned/count").GET();

export type GetNumberOfContractsBatchesResponse = typeof endpoint.types.Res;

export async function getNumberOfContractsBatches(): Promise<GetNumberOfContractsBatchesResponse> {
    const accountOrNetworkId = getAccountOrNetworkId();
    if (!accountOrNetworkId) return { count: 0 };

    const call = createCall(endpoint, (r) =>
        fetch(
            withAccountOrNetworkAuthHeaders(r, { headers: { organisationId: accountOrNetworkId } }),
        ),
    );
    return await call({ params: { organisationId: accountOrNetworkId } });
}
